import { IconBody } from './IconBody'

export default IconBody
